import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar';
import Vision from '../components/About/Vision';
import Footer from '../components/Layout/Footer';



const MissionVision = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
        <Vision />
        <Footer />
        </div>
    </div>
  )
}

export default MissionVision;